import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import FileRepository from '@ckeditor/ckeditor5-upload/src/filerepository';
import ImageHelper from './imageCompressor.js';

export default class Base64UploadAdapter extends Plugin {
  static get requires() {
    return [FileRepository];
  }

  static get pluginName() {
    return 'Base64UploadAdapter';
  }

  init() {
    this.editor.plugins.get(FileRepository).createUploadAdapter = loader => new Adapter(loader);
  }
}

class Adapter {
  constructor(loader) {
    this.loader = loader;
    this.imageHelper = new ImageHelper();
  }

  upload() {
    return new Promise((resolve, reject) => {
      const reader = this.reader = new window.FileReader();

      reader.addEventListener('load', async () => {
        const base64Image = await this.imageHelper.resizeBase64Image({
          base64Image: reader.result,
          compressionAmount: 0.9,
        });
        resolve({ default: base64Image });
      });

      reader.addEventListener('error', (err) => {
        reject(err);
      });

      reader.addEventListener('abort', () => {
        reject();
      });

      this.loader.file.then((file) => {
        reader.readAsDataURL(file);
      });
    });
  }

  abort() {
    this.reader.abort();
  }
}
